import React from "react";

import { WithApolloClient } from "providers/WithApolloClient";
import { WithLoadingContext } from "providers/WithLoadingContext";
import WithEphemeralAppState from "providers/WithEphemeralAppState";

type Props = {
  children: React.ReactElement;
  graphqlUri: string;
};

const App: React.FunctionComponent<Props> = ({ children, graphqlUri }) => {
  return (
    <WithEphemeralAppState>
      <WithLoadingContext>
        <WithApolloClient graphqlUri={graphqlUri}>{children}</WithApolloClient>
      </WithLoadingContext>
    </WithEphemeralAppState>
  );
};

export default App;
